import axios from 'axios';
import React, { useState } from 'react'
import SecurityHeaders from '../../context/SecurityHeaders';
import { Link, useNavigate} from 'react-router-dom';
import { AccountCircle } from '@material-ui/icons';
import { useDispatch } from 'react-redux';

const AddBounty = () => {
  const dispatch = useDispatch()
    const navigation = useNavigate()
    const [image, setImage] = useState(null);
      const [bountyTitle, setBountyTitle] = useState('');
      const [bountyDescription, setBountyDescription] = useState('');
      const [price, setPrice] = useState('');
      const [company, setCompany] = useState('');
      const [payout, setPayout] = useState('');
      const [category, setCategory] = useState('');
      const [link, setLink] = useState('');
      const [upload, setUpload] = useState('');
      const [startDate, setStartDate] = useState('');
      const [status, setStatus] = useState('');
      const [techStack, setTechStack] = useState('');
      const [deadline, setDeadline] = useState('');
      const [rating, setRating] = useState('');
      const [organization_id, setOrganization_id] = useState('');

    
    
      const addBounty = async (e) => {
        e.preventDefault();
        const data = new FormData();
    
        data.append('image', image);
        data.append('bounty_title', bountyTitle);
        data.append('bounty_description', bountyDescription);
        data.append('company', company);
        data.append('payout', payout);
        data.append('category', category);
        data.append('link', link);
        data.append('start_date', startDate);
        data.append('status', status);
        data.append('tech_stack', techStack);
        data.append('deadline', deadline);
        data.append('rating', rating);
        data.append('organization_id', organization_id);
    
        try {
            // Dispatch a loading action
            dispatch({ type: 'LOADING' });
    
            const res = await axios.post("https://skillsuprise.com/add-bounty.php", data, SecurityHeaders);
    
            if (res.data.status === 'success') {
                // Dispatch a success action
                dispatch({ type: 'DONE_LOADING' });
    
                navigation('/bug-bounty');
            } else {
                // Dispatch an error action
                dispatch({ type: 'ERROR', payload: res.data.message });
    
                console.error('Error adding bounty:', res.data.message);
            }
        } catch (error) {
            // Dispatch an error action
            dispatch({ type: 'ERROR', payload: error.message });
    
            console.error('Error while uploading data:', error);
        }
    };
  return (
    <div>
        <div className="d-flex justify-content-center">
                  <div className="card col-12 col-lg-8 col-sm-12 col-md-8 p-4 shadow rounded-3">
                    <h2 className='mb-3 text-primary'>Add Bounty</h2>
                    <form onSubmit={addBounty}>
                      <div className="mb-3">
                        <label htmlFor="profilePic" className="form-label">Image</label>
                        <input type="text" className="form-control" onChange={(e) => setImage(e.target.value)} required />
                    
                      </div>
      
                      <div className="mb-3">
                        <label htmlFor="designation" className="form-label">Name</label>
                        <input type="text" className="form-control" onChange={(e) => setBountyTitle(e.target.value)} required />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="category" className="form-label">Description</label>
                        <input type="text" className="form-control" onChange={(e) => setBountyDescription(e.target.value)} required />
                      </div>
      
                      <div className="mb-3">
                        <label htmlFor="company" className="form-label">Organization Id</label>
                        <input type="number" className="form-control" onChange={(e) => setOrganization_id(e.target.value)} required />
                      </div>
                      
                      <div className="mb-3">
                        <label htmlFor="company" className="form-label">Company</label>
                        <input type="text" className="form-control" onChange={(e) => setCompany(e.target.value)} required />
                      </div>
      
                      <div className="mb-3">
                        <label htmlFor="payout" className="form-label">Payout</label>
                        <input type="number" className="form-control" onChange={(e) => setPayout(e.target.value)} required />
                      </div>
      
                      <div className="mb-3">
                        <label htmlFor="category" className="form-label">Category</label>
                        <input type="text" className="form-control" onChange={(e) => setCategory(e.target.value)} required />
                      </div>
      
                      <div className="mb-3">
                        <label htmlFor="link" className="form-label">Link</label>
                        <input type="text" className="form-control" onChange={(e) => setLink(e.target.value)} required />
                      </div>
      
                    
      
                      <div className="mb-3">
                        <label htmlFor="start_date" className="form-label">Start Date</label>
                        <input type="date" className="form-control" onChange={(e) => setStartDate(e.target.value)} required />
                      </div>
      
                      <div className="mb-3">
                        <label htmlFor="status" className="form-label">Status</label>
                        <select className="form-control" onChange={(e) => setStatus(e.target.value)} required>
                          <option value="">Select Status</option>
                          <option value="open">Open</option>
                          <option value="closed">Closed</option>
                          <option value="in-progress">In Progress</option>
                        </select>
                      </div>
      
                      <div className="mb-3">
                        <label htmlFor="tech_stack" className="form-label">Tech Stack</label>
                        <input type="text" className="form-control" onChange={(e) => setTechStack(e.target.value)} required />
                      </div>
      
                      <div className="mb-3">
                        <label htmlFor="deadline" className="form-label">Deadline</label>
                        <input type="date" className="form-control" onChange={(e) => setDeadline(e.target.value)} required />
                      </div>
      
                      <div className="mb-3">
                        <label htmlFor="rating" className="form-label">Rating</label>
                        <input type="number" className="form-control" min="1" max="5" onChange={(e) => setRating(e.target.value)} required />
                      </div>
      
                      <div className="mb-3">
                        <label htmlFor="category" className="form-label">Price</label>
                        <input type="text" className="form-control" onChange={(e) => setPrice(e.target.value)} required />
                      </div>
      
                      <button type="submit" className="btn btn-primary">Add Bounty</button>
                      <Link to="/bug-bounty" className="btn btn-secondary ms-2">Cancel</Link>
                    </form>
                  </div>
                </div>
    </div>
  )
}

export default AddBounty
